import { ContentParser } from '../../components/ContentParser';
import { CloseIcon } from '../../icons/CloseIcon';
import { Bar, Content, Dismiss, Heading } from './AnnouncementBanner.styles';
import type { AnnouncementBannerProps } from './AnnouncementBanner.types';

export function AnnouncementBanner({
  heading,
  body,
  dismissible = false,
  onDismiss,
  closeLabel = 'Dismiss',
}: AnnouncementBannerProps) {
  return (
    <Bar role="region" aria-label={heading || 'Announcement'}>
      <Content>
        {heading && <Heading>{heading}</Heading>}
        <ContentParser text={body} />
      </Content>
      {dismissible && onDismiss && (
        <Dismiss type="button" onClick={onDismiss} aria-label={closeLabel}>
          <CloseIcon size={18} />
        </Dismiss>
      )}
    </Bar>
  );
}
